import React, { useEffect } from 'react'
import {
  ADS_CHANNEL,
  SELECTED_MEDIA_TYPE,
  METRICS_DATA,
  SPECIFIC_BRAND_DETAIL,
} from '@utils/constants'
import { useDispatch } from 'react-redux'
import DiscoverAdsFeature from './discover-ads-feature'

const DiscoverAds = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch({ type: ADS_CHANNEL, payload: 'Meta' })
    dispatch({ type: 'SET_SELECTED_DESCRIPTIONS', payload: [] })
    dispatch({ type: 'SET_SELECTED_HEADLINES', payload: [] })
    dispatch({ type: 'SET_SELECTED_LANDING_PAGES', payload: [] })
    dispatch({ type: SELECTED_MEDIA_TYPE, payload: [] })
    dispatch({ type: 'SET_SELECTED_MEDIA_TYPE', payload: [] })
    dispatch({ type: 'selected_media_type', payload: [] })
    dispatch({ type: 'SELECTED_ADS_ACTIVITY', payload: [] })
    dispatch({ type: 'SELECTED_HOOKS', payload: [] })
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    dispatch({ type: METRICS_DATA, payload: [] })
    dispatch({ type: SPECIFIC_BRAND_DETAIL, payload: [] })
    // eslint-disable-next-line
  }, [])
  return (
    <>
      <div style={{ padding: 25 }}>
        <DiscoverAdsFeature />
      </div>
    </>
  )
}

export default DiscoverAds
